import { httpApi } from '@app/api/http.api'

export type GetMQTTResponseHistory = Omit<GetMQTTResponse, 'device' | 'device_Id'> & {
  maxValue?: number
  sumValue?: number
  indexValue?: number
  day?: string
}

export type GetMQTTResponse = {
  type: string
  value: string
  createdAt: Date
}

export type GetHistoryChartRequest = {
  id: string
  type: string
  fromDate: string
  toDate: string
  indexes: string | number | undefined
}

export type GetTodayChartRequest = {
  id: string
  type: string
  indexes?: string
}

export type ChartDataResponse = {
  value: number
  createdAt: Date
}

export type HistoryChartResponse = {
  id: string
  type: string
  value: number
  createdAt: Date
}

export type GetMQTTPayload = {
  id: string
  selectedTemplateId: string
}

const MQTT = 'mqtt'

export const getMqtt = (getMqttPayload: GetMQTTPayload): Promise<GetMQTTResponse[]> =>
  httpApi.post<GetMQTTResponse[]>(`${MQTT}/data`, { ...getMqttPayload }).then(({ data }) => data)

export const getTodayChartData = (mqttTypePayload: GetTodayChartRequest): Promise<ChartDataResponse[]> =>
  httpApi.post<ChartDataResponse[]>(`${MQTT}/history/today`, { ...mqttTypePayload }).then(({ data }) => data)

export const getHistoryChartDataDailyHighest = (
  mqttTypePayload: GetHistoryChartRequest,
): Promise<ChartDataResponse[]> =>
  httpApi
    .post<ChartDataResponse[]>(`${MQTT}/history-chart-data-daily-highest`, { ...mqttTypePayload })
    .then(({ data }) => data)

export const getHistoryChartLastDataDaily = (mqttTypePayload: GetHistoryChartRequest): Promise<ChartDataResponse[]> =>
  httpApi
    .post<ChartDataResponse[]>(`${MQTT}/history-chart-last-data-daily`, { ...mqttTypePayload })
    .then(({ data }) => data)

export const getRawMeasurementsForCSV = (mqttTypePayload: GetHistoryChartRequest): Promise<ChartDataResponse[]> =>
  httpApi.post<ChartDataResponse[]>(`${MQTT}/raw-measurements-csv`, { ...mqttTypePayload }).then(({ data }) => data)
